module.exports = __webpack_public_path__ + "img/Pakistan Studies.20263536.svg";